@if (questions) {
	<tabset justified="true" class="sidebar-tabset sidebar-tabset-scrollable">
		<tab [heading]="'Event_QA_List_Inbox' | translate : { '0': inboxQuestions.length }" tabOrder="1" role="menuitem">
			@if (questionCounts.hidden > 0) {
				<div class="margin-top-10 d-flex justify-content-center">
					<button type="button" vbBtnPrimary (click)="showNewQuestions()">
						<span [ngPlural]="questionCounts.hidden">
							<ng-template ngPluralCase="=1">{{ 'Event_QA_IncomingQuestionsCountSingular' | translate : { '0': questionCounts.hidden } }}</ng-template>
							<ng-template ngPluralCase="other">{{ 'Event_QA_IncomingQuestionsCountPlural' | translate : { '0': questionCounts.hidden } }}</ng-template>
						</span>
					</button>
				</div>
			}
			@if (inboxQuestions.length) {
				<vb-webcast-questions-list [context]="context" [webcast]="webcast" [questions]="inboxQuestions">
				</vb-webcast-questions-list>
			} @else {
				<div class="margin-top-20">{{ 'Event_QA_NoQuestions' | translate }}</div>
			}
		</tab>
		<tab [heading]="'Event_QA_List_Queue' | translate: { '0': queuedQuestions.length }" tabOrder="2" role="menuitem">
			@if (queuedQuestions.length) {
				<vb-webcast-questions-list [context]="context" [webcast]="webcast" [questions]="queuedQuestions" [allowReordering]="true">
				</vb-webcast-questions-list>
			} @else {
				<div class="margin-top-20">{{ 'Event_QA_NoQuestions' | translate }}</div>
			}
		</tab>
		<tab [heading]="'Event_QA_List_Closed' | translate: { '0': closedQuestions.length }" tabOrder="3" role="menuitem">
			<div class="d-flex justify-content-between align-items-center margin-top-20">
				@if (!closedQuestions.length) {
					<div>{{ 'Event_QA_NoQuestions' | translate }}</div>
				}
				<div dropdown vbDropdown [ngClass]="styles.closedQuestionsFilterMenu" class="menu-wrapper ms-auto">
					<button type="button" id="closedQuestionsFilterBtn" vbBtnSecondary dropdownToggle class="icon-btn">
						<span class="vb-icon vb-icon-sort-by"></span>&nbsp;{{ (closedQuestionsFilterLabel || 'All') | translate }}
					</button>

					<ul *dropdownMenu class="dropdown dropdown-menu dropdown-menu-right" id="closedQuestionsFilterMenu" role="menu" aria-labelledby="closedQuestionsFilterBtn">
						<li>
							<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.All, $event.target.innerText)">
								{{ 'All' | translate }}
							</button>
						</li>
						<li>
							<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.Answered, $event.target.innerText)">
								{{ 'Event_QA_Answered' | translate }}
							</button>
						</li>
						<li>
							<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.Declined, $event.target.innerText)">
								{{ 'Event_QA_Declined' | translate }}
							</button>
						</li>
						<li>
							<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.RepliedDirectly, $event.target.innerText)">
								{{ 'Event_QA_Closed_Replied' | translate }}
							</button>
						</li>
						<li>
							<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.FollowUp, $event.target.innerText)">
								{{ 'Event_QA_FollowUp' | translate }}
							</button>
						</li>
						<li>
							<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.Closed, $event.target.innerText)">
								{{ 'Event_QA_Closed' | translate }}
							</button>
						</li>
					</ul>
				</div>
			</div>
			@if (closedQuestions.length) {
				<vb-webcast-questions-list [context]="context" [webcast]="webcast" [questions]="closedQuestions">
				</vb-webcast-questions-list>
			}
		</tab>
	</tabset>
	<vb-webcast-ask-question class="width-full margin-bottom-10" [context]="context" [webcast]="webcast">
	</vb-webcast-ask-question>
}
